import PropTypes from 'prop-types';
import React, { Component } from "react";
import {
  Alert,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table
} from "reactstrap";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";


// actions
import { editProfile, resetProfileFlag } from "../../store/actions";


class UserProfile extends Component {
  constructor(props) {
    super(props)
    this.state = { email: "", name: "", idx: 1 }

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.editProfile(values)
  }

  componentDidMount() {
    if (localStorage.getItem("username")) {
      this.setState({ name: localStorage.getItem("username"), idx :localStorage.getItem("branchId"), email:localStorage.getItem("lastname") })
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumb title="WeChip" breadcrumbItem="Profile" />

            <Row>
              <Col lg="6">
                {this.props.error ? (
                  <Alert color="danger">{this.props.error}</Alert>
                ) : null}
                {this.props.success ? (
                  <Alert color="success">{this.props.success}</Alert>
                ) : null}

                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="me-3">
                        
                      </div>
                      <div className="align-self-center flex-1">
                        <div className="text-muted">
                          <h5>{this.state.name}</h5>
                          <p className="mb-1">{this.state.email}</p>
                          <p className="mb-0">Guid: {this.state.idx}</p>
                          <p className="text-muted mb-4"> Prefferred Language: {localStorage.getItem("I18N_LANGUAGE")}</p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4 h4">Personal Information</CardTitle>

                    
                    <div className="table-responsive">
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">Full Name :</th>
                            <td>{localStorage.getItem("username")}</td>
                          </tr>
                          <tr>
                            <th scope="row">Mobile :</th>
                            <td>{localStorage.getItem("phone")}</td>
                          </tr>
                          <tr>
                            <th scope="row">E-mail :</th>
                            <td>{localStorage.getItem("email")}</td>
                          </tr>
                          <tr>
                            <th scope="row">Address :</th>
                            <td>{localStorage.getItem("address")}</td>
                          </tr>
                          <tr>
                            <th scope="row">Date of Birth :</th>
                            <td>{localStorage.getItem("dateOfBirth")}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    )
  }
}

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  resetProfileFlag: PropTypes.func
}

const mapStateToProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStateToProps, { editProfile, resetProfileFlag })(UserProfile)
)
